module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.router && _vm.router.name) ? _c('router-link', {
    staticClass: "treeview",
    attrs: {
      "tag": "li",
      "to": _vm.router
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', [_c('img', {
    class: _vm.icon
  })]), _vm._v(" "), _c('span', {
    staticClass: "side-parent"
  }, [_vm._v(_vm._s(_vm.name))])])]) : _c('li', {
    class: _vm.getType
  }, [_vm._v("\n  " + _vm._s(_vm.isHeader ? _vm.name : '') + "\n  "), _c('a', {
    attrs: {
      "href": "#"
    }
  }, [_c('div', [_c('img', {
    class: _vm.icon
  })]), _c('span', {
    staticClass: "side-sub"
  }, [_vm._v(_vm._s(_vm.name))])]), _vm._v(" "), (_vm.items.length > 0) ? _c('ul', {
    staticClass: "treeview-menu",
    staticStyle: {
      "width": "250px"
    },
    attrs: {
      "id": "treeMenu"
    }
  }, [_vm._l((_vm.items), function(item, index) {
    return (item.router && item.router.name) ? _c('router-link', {
      key: index,
      attrs: {
        "tag": "li",
        "data": item,
        "to": item.router
      }
    }, [(_vm.window.width < 450) ? _c('a', [_c('div', {
      staticClass: "sub-menu"
    }, [_vm._v(_vm._s(_vm._f("abbreviation")(item.name)))])]) : _c('a', [_c('div', {
      staticClass: "sub-menu"
    }, [_c('img', {
      class: _vm.icon,
      staticStyle: {
        "width": "32px"
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "sub-menu-label"
    }, [_vm._v(_vm._s(item.name))])])])]) : _c('li', [_c('a', [_c('div', {
      staticClass: "sub-menu"
    }, [_c('img', {
      class: _vm.icon,
      staticStyle: {
        "width": "32px"
      }
    }), _c('div', {
      staticClass: "sub-menu-label"
    }, [_vm._v(_vm._s(item.name))])])])])
  }), _vm._v(" "), (_vm.window.width > 450) ? _c('li', {
    staticClass: "li-end"
  }) : _vm._e()], 2) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-5838206e!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/navigation/VASlideOrangeItem.vue
// module id = 523
// module chunks = 1